import { render } from "./EditBirth.vue?vue&type=template&id=5b2581b2&scoped=true"
import script from "./EditBirth.vue?vue&type=script&lang=js"
export * from "./EditBirth.vue?vue&type=script&lang=js"

import "./EditBirth.vue?vue&type=style&index=0&id=5b2581b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2581b2"]])

export default __exports__